import routes from '@modules/subproperty-settings/customize-settings/customize-settings-routes';

export default {
  routes,
};
